import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const DynamicStyles: React.FC = () => {
  const { theme } = useTheme();

  const generateStyles = () => {
    return `
      :root {
        /* Primary Colors */
        --color-primary-50: ${theme.colors.primary[50]};
        --color-primary-100: ${theme.colors.primary[100]};
        --color-primary-200: ${theme.colors.primary[200]};
        --color-primary-300: ${theme.colors.primary[300]};
        --color-primary-400: ${theme.colors.primary[400]};
        --color-primary-500: ${theme.colors.primary[500]};
        --color-primary-600: ${theme.colors.primary[600]};
        --color-primary-700: ${theme.colors.primary[700]};
        --color-primary-800: ${theme.colors.primary[800]};
        --color-primary-900: ${theme.colors.primary[900]};

        /* Secondary Colors */
        --color-secondary-50: ${theme.colors.secondary[50]};
        --color-secondary-100: ${theme.colors.secondary[100]};
        --color-secondary-200: ${theme.colors.secondary[200]};
        --color-secondary-300: ${theme.colors.secondary[300]};
        --color-secondary-400: ${theme.colors.secondary[400]};
        --color-secondary-500: ${theme.colors.secondary[500]};
        --color-secondary-600: ${theme.colors.secondary[600]};
        --color-secondary-700: ${theme.colors.secondary[700]};
        --color-secondary-800: ${theme.colors.secondary[800]};
        --color-secondary-900: ${theme.colors.secondary[900]};

        /* Theme Variables */
        --color-accent: ${theme.colors.accent};
        --color-background: ${theme.colors.background};
        --color-surface: ${theme.colors.surface};
        --color-error: ${theme.colors.error};
        --color-warning: ${theme.colors.warning};
        --color-success: ${theme.colors.success};
        --color-text-primary: ${theme.colors.text.primary};
        --color-text-secondary: ${theme.colors.text.secondary};
        --color-text-disabled: ${theme.colors.text.disabled};

        /* Typography */
        --font-primary: ${theme.branding.font.primary};
        --font-secondary: ${theme.branding.font.secondary};

        /* Border Radius */
        --border-radius-small: ${theme.branding.borderRadius.small};
        --border-radius-medium: ${theme.branding.borderRadius.medium};
        --border-radius-large: ${theme.branding.borderRadius.large};

        /* Shadows */
        --shadow-small: ${theme.branding.shadows.small};
        --shadow-medium: ${theme.branding.shadows.medium};
        --shadow-large: ${theme.branding.shadows.large};
      }

      /* Dynamic class overrides */
      .bg-primary-500 {
        background-color: var(--color-primary-500) !important;
      }

      .bg-primary-600 {
        background-color: var(--color-primary-600) !important;
      }

      .hover\\:bg-primary-600:hover {
        background-color: var(--color-primary-600) !important;
      }

      .text-primary-600 {
        color: var(--color-primary-600) !important;
      }

      .text-primary-500 {
        color: var(--color-primary-500) !important;
      }

      .border-primary-500 {
        border-color: var(--color-primary-500) !important;
      }

      .ring-primary-500 {
        --tw-ring-color: var(--color-primary-500) !important;
      }

      .focus\\:ring-primary-500:focus {
        --tw-ring-color: var(--color-primary-500) !important;
      }

      .accent-primary {
        accent-color: var(--color-primary-500) !important;
      }

      /* Secondary color overrides */
      .bg-secondary-500 {
        background-color: var(--color-secondary-500) !important;
      }

      .text-secondary-600 {
        color: var(--color-secondary-600) !important;
      }

      /* Button styles for themes */
      .btn-primary {
        background-color: var(--color-primary-500);
        color: white;
        font-family: var(--font-primary);
        border-radius: var(--border-radius-medium);
        box-shadow: var(--shadow-small);
        transition: all 0.2s ease;
      }

      .btn-primary:hover {
        background-color: var(--color-primary-600);
        box-shadow: var(--shadow-medium);
      }

      .btn-secondary {
        background-color: var(--color-secondary-500);
        color: white;
        font-family: var(--font-primary);
        border-radius: var(--border-radius-medium);
        box-shadow: var(--shadow-small);
        transition: all 0.2s ease;
      }

      .btn-secondary:hover {
        background-color: var(--color-secondary-600);
        box-shadow: var(--shadow-medium);
      }

      /* Theme-specific overrides */
      ${theme.id === 'kfc' ? `
        .theme-header {
          background: linear-gradient(135deg, ${theme.colors.primary[500]} 0%, ${theme.colors.primary[700]} 100%);
          font-family: ${theme.branding.font.primary};
        }
        .theme-accent {
          color: ${theme.colors.accent};
        }
      ` : ''}

      ${theme.id === 'mcdonalds' ? `
        .theme-header {
          background: linear-gradient(135deg, ${theme.colors.primary[500]} 0%, ${theme.colors.secondary[500]} 100%);
          font-family: ${theme.branding.font.primary};
        }
        .theme-accent {
          color: ${theme.colors.accent};
        }
      ` : ''}

      ${theme.id === 'subway' ? `
        .theme-header {
          background: linear-gradient(135deg, ${theme.colors.primary[500]} 0%, ${theme.colors.primary[600]} 100%);
          font-family: ${theme.branding.font.primary};
        }
        .theme-accent {
          color: ${theme.colors.accent};
        }
      ` : ''}
    `;
  };

  return <style dangerouslySetInnerHTML={{ __html: generateStyles() }} />;
};

export default DynamicStyles;